<template>
  <div>
      <section class="hero is-medium is-dark">
        <div class="hero-body bg-img">
            <div class="container">
            <h1 class="title is-1">
                <div v-if="parametros != 'todo'">
                    {{ parametros.toUpperCase() }}
                </div>
                <div v-else>
                    {{"Productos".toUpperCase()}}
                </div>
            </h1>
            </div>
        </div>
    </section>
    <section class="section">
        <div class="container">
            <b-collapse class="card" :open="false" aria-id="filtersArea" animation="slide">
                <div
                    slot="trigger" 
                    slot-scope="props"
                    class="card-header"
                    role="button"
                    aria-controls="filtersArea">
                    <p class="card-header-title">
                        Filtros
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-up' : 'menu-down'">
                        </b-icon>
                    </a>
                </div>
                <div class="card-content">
                    <div class="content">
                        <div class="columns">
                            <div class="column">
                                <b-field label="Rango de precios">
                                    <b-slider class="is-medium" label="Rango de precio"></b-slider>
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field label="Categoria">
                                    <b-taginput
                                        v-model="categorias"
                                        autocomplete
                                        :allow-new="false"
                                        icon="label"
                                        placeholder="Categorías de productos"
                                        :data="filteredTags"
                                        @typing="getFilteredTags"
                                        field="name">
                                    </b-taginput>
                                </b-field>
                            </div>
                            <!-- <div class="column">
                                <b-slider label="Rango de precio"></b-slider>
                            </div> -->
                        </div>
                    </div>
                </div>
                <!-- <footer class="card-footer">
                    <a class="card-footer-item">Save</a>
                    <a class="card-footer-item">Edit</a>
                    <a class="card-footer-item">Delete</a>
                </footer> -->
            </b-collapse>
        </div>
    </section>
    <!-- <section class="section">
        <hr>
    </section> -->
    <section class="section">
        <!-- allProducts.slice(((current-1)*range), (((current-1)*range)+12)) -->
        <ProductsList :productList="allProducts.slice(((current-1)*range), (((current-1)*range)+12))"/>
    </section>
    <section class="section">
        <div class="container">
        <b-pagination class="is-medium" :total="allProducts.length" :current.sync="current" :range-after="3" :range-before="3" :order=order :per-page="range" @change="onChange"></b-pagination>
        </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import ProductsList from '@/components/ProductsList.vue'

export default {
    name: 'Products',
    components: {
        ProductsList
    },
    data() {
        return {
            parametros: {},
            no_data: false,
            current: 1,
            order: 'is-centered',
            range: 12,
            categorias: [],
            filteredTags: null
        }
    },
    methods: {
        ...mapActions(["fetchProducts"]),
        onChange(number) {
            
        },
        fetchData() {
            this.parametros = this.$route.params.categoria
        },
        getFilteredTags(text) {
            this.filteredTags = this.allProducts.filter((option) => {
                return option.name
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        }
    },
    computed: mapGetters(["allProducts"]),
    created() {
        this.fetchData()
        this.fetchProducts()
        this.filteredTags = this.allProducts
    },
    watch: {
        '$route' : 'fetchData'
    }
}
</script>

<style>
    .bg-img { 
        background-image: url(https://images.unsplash.com/photo-1555664424-778a1e5e1b48?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80) ;
        background-position: center center;
        background-repeat:  no-repeat;
        background-attachment: fixed;
        background-size:  cover;
        background-color: #999;
    }
</style>